import { renderEmbeddedEntry, renderMark, renderText } from "@2u-landing-pages/utils/contentful-richtext";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { Body, Container, Subhead } from "@red-digital/bricks";
import cn from "classnames";
import React from "react";
import { Icon } from "../../../Icon";
import { CustomCSSProperties, TileProps } from "../../Tile.types";
// @ts-ignore
import styles from "./Divider.module.scss";

export const Divider: React.FC<TileProps> = ({
  content,
  padded,
  variation,
  body,
  className,
  style: styleProps,
  textAlign,
  inspector,
  parseMetadata,
}) => {
  const fields = content?.fields || {};
  const style: CustomCSSProperties = { ...styleProps };

  if (content?.fields?.background_color) style["--tile-background-color"] = `var(${content?.fields?.background_color})`;
  if (content?.fields?.image_aspect_ratio) style["--tile-image-aspect-ratio"] = content?.fields?.image_aspect_ratio;

  if (!content) return null;

  return (
    <Container
      flex
      style={style}
      className={cn(className, styles.tile, {
        [styles.padded]: padded,
        [styles.textAlignLeft]: textAlign === "left",
      })}
    >
      <div className={styles.title}>
        {fields.icon && (
          <div className={styles.slot}>
            {!fields.image && fields.icon && (
              <Icon
                name={fields.icon}
                size={fields.icon_size}
                className={styles.icon}
                {...inspector({
                  entryId: content.sys.id,
                  fieldId: "icon",
                })}
              />
            )}
          </div>
        )}
        {fields?.eyebrow &&
          typeof fields?.eyebrow === "object" &&
          documentToReactComponents(fields?.eyebrow, {
            renderMark,
            renderText: (text) => renderText(parseMetadata ? parseMetadata(text) : text),
            renderNode: {
              [BLOCKS.PARAGRAPH]: (node, children) => (
                <Subhead
                  type="span"
                  className={styles.eyebrow}
                  variant="subhead-sm"
                  modifier={400}
                  {...inspector({
                    entryId: content.sys.id,
                    fieldId: "eyebrow",
                  })}
                >
                  {children}
                </Subhead>
              ),
              [INLINES.EMBEDDED_ENTRY]: (node) => renderEmbeddedEntry(node, "Tile Eyebrow", fields?.eyebrow),
            },
          })}
      </div>
      <div className={styles.content}>
        {fields?.body &&
          documentToReactComponents(fields?.body, {
            renderMark,
            renderText: (text) => renderText(parseMetadata ? parseMetadata(text) : text),
            renderNode: {
              [BLOCKS.PARAGRAPH]: (node, children) => (
                <Body
                  variant="body-md"
                  {...body}
                  className={cn(styles.body, {
                    [styles.badgeBody]: variation === "badge",
                  })}
                  {...inspector({
                    entryId: content.sys.id,
                    fieldId: "body",
                  })}
                >
                  {children}
                </Body>
              ),
              [INLINES.EMBEDDED_ENTRY]: (node) => renderEmbeddedEntry(node, "Tile Body", fields?.body),
            },
          })}
      </div>
    </Container>
  );
};
